import { apiFetch } from './client';

export const adminApi = {
  productionStatus: () => apiFetch('/api/admin/production-status'),
  cleanupTestData: (dryRun = true) =>
    apiFetch('/api/admin/cleanup-test-data', { method: 'POST', params: { dry_run: dryRun } }),
  reconcileCalls: () => apiFetch('/api/admin/reconcile-calls', { method: 'POST' }),
  refreshDncList: (body) =>
    apiFetch('/api/admin/refresh-dnc-list', { method: 'POST', body }),
  testCall: () => apiFetch('/api/admin/test-call'),
  auditTrail: () => apiFetch('/api/audit/trail'),
};

export const complianceApi = {
  checkLead: (body) =>
    apiFetch('/api/compliance/check-lead', { method: 'POST', body }),
};

export const opsApi = {
  health: () => apiFetch('/api/ops/health'),
  alerts: () => apiFetch('/api/ops/alerts'),
  ackAlert: (alertId) =>
    apiFetch('/api/ops/alerts/ack', { method: 'POST', body: { alert_id: alertId } }),
  tuneAlerts: (body) => apiFetch('/api/ops/alerts/tune', { method: 'POST', body }),
};
